import { APICore } from "../apiCore";

const api = new APICore();

function search(term) {
    return api.update('/search', { term });
}

export { search };
